import { Route, Routes } from "react-router";

import { RequestDetailPage } from "./pages/RequestDetailPage";
import { RequestQueuePage } from "./pages/RequestQueuePage";

/**
 * The request routes, mounted at `/requests/*` (CHT-750 to CHT-752):
 *   /requests              the queue (`?filter=` keeps the filter)
 *   /requests/:requestId   one request: the context, the history, the commands
 */
export function RequestsRoutes() {
  return (
    <Routes>
      <Route index element={<RequestQueuePage />} />
      <Route path=":requestId" element={<RequestDetailPage />} />
    </Routes>
  );
}
